module.exports = __webpack_public_path__ + "static/01-5eec2521a32383be34e97322d212ef6f.jpg";